import { render, staticRenderFns } from "./PhoneAnswerComponent.vue?vue&type=template&id=b0aba5b6&scoped=true&"
import script from "./PhoneAnswerComponent.vue?vue&type=script&lang=ts&"
export * from "./PhoneAnswerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aba5b6",
  null
  
)

export default component.exports